import { Link } from "@tanstack/react-router";
import { ArrowRight } from "lucide-react";

export function AboutContent() {
  return (
    <div className="w-full max-w-[540px] px-6">
      <div className="text-left">
        <h2 className="m-0 text-[28px] sm:text-[32px] md:text-[36px] leading-tight font-extrabold text-black">
          The efficiency of AI.
          <br />
          The precision of code.
          <br />
          And the expertise of your team.
        </h2>
      </div>
      <div className="mt-6 space-y-4 text-[15px] leading-[1.6] text-black/90 text-justify">
        <p>
          CoPlane blends agents, deterministic rules, and context-rich human
          approvals into one enterprise-grade system for the enterprise. CoPlane
          automates core finance and operations processes, including Accounts
          Payable, Accounts Receivable, Procurement, and Financial Operations.
        </p>
        <p>
          Teams can automate invoice processing, exception handling,
          reconciliation, and reporting—integrating seamlessly with systems like
          SAP, Workday, and Coupa.
        </p>
        <ul className="list-disc pl-6 space-y-2">
          <li>
            Agents execute data extraction, classification, and reasoning; call
            tools; and generate artifacts.
          </li>
          <li>
            Rules encode policies, guardrails, and approvals as deterministic
            logic.
          </li>
          <li>
            Human steps deliver just-in-time UIs for exceptions and decisions.
          </li>
        </ul>
        <p>
          CoPlane is enterprise-ready with end-to-end auditability,
          fault-tolerant execution, and deployment inside your trust boundary
          (your cloud, your LLM).
        </p>
        <div className="flex justify-center">
          <Link
            to="/manifesto"
            className="inline-flex items-center rounded-full border border-black/20 px-3 py-1 text-xs font-semibold text-black/60 hover:bg-black/10 transition-colors"
          >
            Read our manifesto.
            <ArrowRight className="w-4 h-4 ml-1 inline" />
          </Link>
        </div>
      </div>
    </div>
  );
}
